import { FORM } from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';

export default function mediasCategoriesConfig (categories,categorieSelected,imagePath,type){
    
    var obj={
        langSelect: false,
        drawerType: 'swipeable',
        noForm: true,
        component: Button,
        titleForm: 'Modifier un média',
        subTitleForm: 'Veuillez compléter les champs ci-dessous pour modifier votre média',
        textButtonValidate: 'Modifier',
        formConfig:{
            type:FORM,
            
            children:[ 
                    {
                        optionsInputs:[
                            {
                                type:'simpleImage',
                                label: 'Image',
                                translated: false,
                                helper: {
                                    text: 'Image',
                                    link: false,
                                },
                                imagepath : imagePath,
                                mediaType:type,
                                
                            },                            
                           {
                                type:'text',
                                label: 'Nom du média',
                                translated: false,
                                helper: {
                                    text: 'Nom du média',
                                    link: false,
                                },
                                required: false,
                                stateName: 'fileName',
                            },
                            {
                                type:'text',
                                label: 'Texte alternatif',
                                translated: false,
                                helper: {
                                    text: 'Aide à la SEO et à l\'accessibilité',
                                    link: false,
                                },
                                required: false,
                                stateName: 'fileAlt',
                            },

                            {
                                type: 'selectTree',
                                multiselect : true,
                                label: 'Dossier',
                                translated: false,
                                helper: {
                                    text: 'Indiquez le dossier de destination du média',
                                    link: false,
                                },
                                
                                stateName: 'parent',
                                data: (() => {
                                    /*let tree    = [];
                                    let root    = 
                                    {
                                        children    : [],
                                        checked     : categorieSelected.length>0 ? false : true,
                                        expanded    : true,
                                        label       : '/',
                                        node        : 
                                        {
                                            id: "root",
                                            libelle: "/",
                                            parent: null 
                                        }
                                    }*/
                                    let data = categories.filter(e => e.node.parent === null);
                                    
                                    let populateChildren = (cats, parent) => {
                                      
                                        let catSelected         = categorieSelected.find(e => e === parent.node.id);
                                        parent.value            = parent.node.id;
                                        parent.label            = parent.node.libelle;
                                        parent.children         = cats.filter(e => e.node.parent !== null && e.node.parent.id === parent.node.id);
                                        parent.checked          = catSelected ? true : false;
                                        parent.expanded         = true;

                                        
                                        for (let child of parent.children){
                                            populateChildren(cats, child);                                            
                                        }
                                    };
    
                                    for (let parent of data){
                                        populateChildren(categories, parent); 
                                    }
                                    /*root.children=data;
                                    tree=tree.concat(root);*/
                                        
    
                                    return data;


                                })()
                            }
                        ]   
                    }
            ]
        }

    }
    return obj;
}